var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTimer),expression:"showTimer"}],staticClass:"timer-overlay-container",class:_vm.timerClass},[_c('div',{staticClass:"timer-overlay"},[_c('Icon',{attrs:{"value":"Timer","color":"white"}}),_c('span',[_vm._v(_vm._s(_vm.timeString))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }